import { TextValue, type TextValueProps } from "../../values/text-value";
import { LayoutGroupItem } from "../layout-group-item";
import { type CommonLayoutValueProps } from "./types";

export type TextLayoutValueProps = TextValueProps & CommonLayoutValueProps;

export function TextLayoutValue({
  label,
  tooltip,
  layoutClassName,
  labelClassName,
  ...props
}: TextLayoutValueProps) {
  return (
    <LayoutGroupItem
      label={label}
      tooltip={tooltip}
      className={layoutClassName}
      labelClassName={labelClassName}
    >
      <TextValue {...props} />
    </LayoutGroupItem>
  );
}
